<template>
  <div class="seller-currency-config">
    <div class="main-currency-row">
      <span class="form-label">主货币:</span>
      <el-select v-model="form.mainCurrency" class="main-currency-select" filterable>
        <el-option v-for="item in currencyOptions" :key="item.value" :label="item.label"
          :value="item.value"></el-option>
      </el-select>
      <span class="main-currency-tip">修改后请填写谷歌验证码并确认；变更主货币时将二次确认。</span>
    </div>

    <div class="currency-table-row">
      <span class="form-label table-label">启用的币种:</span>
      <el-table :data="currencyRows" border class="seller-currency-table"
        :header-cell-style="{ background: '#f2f3f5', color: '#606266' }" :cell-style="{ padding: '0' }">
        <el-table-column label="币种" align="center">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.Enabled" @change="handleCurrencyEnabledChange(scope.row)">
              <span :class="{ 'enabled-currency-code': scope.row.Enabled }">{{
                scope.row.CurrencyCode
                }}</span>
            </el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="启用的钱包类型" align="center">
          <template slot-scope="scope">
            <el-checkbox-group v-if="scope.row.Enabled" v-model="scope.row.WalletTypes" class="wallet-type-group">
              <el-checkbox label="real" disabled>真金</el-checkbox>
              <el-checkbox label="bonus">彩金</el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" width="160">
          <template slot="header">
            <span>是否支持自营游戏下注</span>
            <el-tooltip content="开启后该币种可用于自营游戏下注" placement="top">
              <i class="el-icon-question header-tip-icon"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-switch v-if="scope.row.Enabled" v-model="scope.row.SelfGameBet" active-color="#13ce66"
              inactive-color="#ff4949"></el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="248">
          <template slot="header">
            <span>是否直接带入三方游戏</span>
            <el-tooltip content="开启后该币种直接带入三方游戏；关闭时可配置映射币种" placement="top">
              <i class="el-icon-question header-tip-icon"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.Enabled" class="third-game-cell">
              <el-switch v-model="scope.row.DirectThirdGame" active-color="#13ce66"
                inactive-color="#ff4949"></el-switch>
              <el-select v-if="!scope.row.DirectThirdGame || scope.row.DirectThirdSymbol !== ''"
                v-model="scope.row.DirectThirdSymbol" class="third-game-select" filterable>
                <el-option v-for="item in currencyOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="支持下注的游戏" align="center" width="110">
          <template slot-scope="scope">
            <el-button type="text" class="setting-link" @click="openGameDialog(scope.row)">设置</el-button>
          </template>
        </el-table-column>
        <el-table-column label="搬汇手续费(按币种设置)" align="center" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.ShowExchangeFee" class="fee-cell">
              <el-input v-model.trim="scope.row.ExchangeFee" class="fee-input"></el-input>
              <span>%</span>
            </div>
          </template>
        </el-table-column> -->
      </el-table>
    </div>

    <!-- <div class="bonus-name-row">
      <span class="form-label">BONUS名称:</span>
      <div class="bonus-name-content">
        <div class="language-buttons">
          <el-button v-for="item in languages" :key="item.code" size="small"
            :type="form.activeLanguage == item.code ? 'primary' : 'default'" @click="form.activeLanguage = item.code">{{
              item.label }}</el-button>
        </div>
        <div class="bonus-input-label">请输入【{{ activeLanguageLabel }}】名称</div>
        <el-input v-model.trim="form.bonusNames[form.activeLanguage]" maxlength="14" show-word-limit
          placeholder="请输入BONUS名称" class="bonus-name-input"></el-input>
      </div>
    </div> -->

    <!-- <div class="rate-rules">
      <div v-for="item in rateRuleRows" :key="item.key" class="rate-rule-row">
        <span class="required-star">*</span>
        <span class="rate-rule-label">{{ item.label }}:</span>
        <el-tooltip :content="item.tooltip" placement="top">
          <i class="el-icon-question rate-tip-icon"></i>
        </el-tooltip>
        <el-radio-group v-model="form.rateRules[item.key].type">
          <el-radio :label="1">固有值</el-radio>
          <el-radio :label="2">百分比</el-radio>
        </el-radio-group>
        <el-input v-model.trim="form.rateRules[item.key].value" class="rate-value-input"></el-input>
        <span>%</span>
      </div>
    </div> -->

    <div class="google-code-row">
      <span class="required-star">*</span>
      <span class="google-label">谷歌验证码:</span>
      <el-input v-model.trim="form.googleCode" placeholder="谷歌验证码" class="google-input"></el-input>
    </div>

    <div class="seller-currency-footer">
      <el-button @click="$emit('close')">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>

    <el-dialog title="支持下注的游戏" :visible.sync="gameDialog.show" width="520px" center append-to-body>
      <el-checkbox-group v-model="gameDialog.selected" class="game-options">
        <el-checkbox v-for="item in gameOptions" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="game-dialog-footer">
        <el-button @click="gameDialog.show = false">取消</el-button>
        <el-button type="primary" @click="saveGameDialog">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { app } from "@/api/app.js";

const LANGUAGES = [
  { label: "中文(zh)", code: "zh" },
  { label: "英语(en)", code: "en" },
  { label: "泰语(th)", code: "th" },
  { label: "韩语(ko)", code: "ko" },
  { label: "土耳其语(tr)", code: "tr" },
  { label: "越南语(vi)", code: "vi" },
  { label: "葡萄牙语(pt)", code: "pt" },
  { label: "印地语(hi)", code: "hi" },
  { label: "日语(ja)", code: "ja" },
  { label: "俄语(ru)", code: "ru" },
  { label: "柬埔寨语(km)", code: "km" },
  { label: "乌克兰语(uk)", code: "uk" },
  { label: "中文繁体(zh-TW)", code: "zh-TW" },
  { label: "西班牙语(es)", code: "es" },
  { label: "马来语(ms)", code: "ms" },
  { label: "阿拉伯语(ar)", code: "ar" },
  { label: "德语(de)", code: "de" },
  { label: "法语(fr)", code: "fr" },
  { label: "印尼语(in)", code: "in" },
  { label: "菲律宾语(tl)", code: "tl" },
];

const RATE_RULE_ROWS = [
  {
    key: "rechargeFiat",
    label: "充值汇率偏差值-法币",
    tooltip: "法币充值时使用的汇率偏差配置",
  },
  {
    key: "rechargeVirtual",
    label: "充值汇率偏差值-虚拟币",
    tooltip: "虚拟币充值时使用的汇率偏差配置",
  },
  {
    key: "withdrawFiat",
    label: "提现汇率偏差值-法币",
    tooltip: "法币提现时使用的汇率偏差配置",
  },
  {
    key: "withdrawVirtual",
    label: "提现汇率偏差值-虚拟币",
    tooltip: "虚拟币提现时使用的汇率偏差配置",
  },
];

function createCurrencyRow(row) {
  return {
    CurrencyCode: row.CurrencyCode || "",
    CurrencyName: row.CurrencyName || row.CurrencyCode || "",
    Enabled: !!row.Enabled,
    WalletTypes: Array.isArray(row.WalletTypes) ? row.WalletTypes.slice() : [],
    SelfGameBet: !!row.SelfGameBet,
    DirectThirdGame: !!row.DirectThirdGame,
    DirectThirdSymbol:
      row.DirectThirdSymbol === undefined || row.DirectThirdSymbol === null
        ? ""
        : String(row.DirectThirdSymbol),
    SupportGames: Array.isArray(row.SupportGames) ? row.SupportGames.slice() : [],
    ExchangeFee:
      row.ExchangeFee === undefined || row.ExchangeFee === null
        ? ""
        : String(row.ExchangeFee),
    ShowExchangeFee: !!row.ShowExchangeFee,
  };
}

function createDefaultRows() {
  return [];
}

function createBonusNames() {
  return LANGUAGES.reduce((result, item) => {
    result[item.code] = "";
    return result;
  }, {});
}

function createRateRules() {
  return {
    rechargeFiat: { type: 2, value: "5" },
    rechargeVirtual: { type: 2, value: "6" },
    withdrawFiat: { type: 2, value: "7" },
    withdrawVirtual: { type: 2, value: "8" },
  };
}

export default {
  name: "SellerCurrencyConfigDialog",
  props: {
    sellerId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      currencyRows: createDefaultRows(),
      form: {
        mainCurrency: "USDT",
        activeLanguage: "zh",
        bonusNames: createBonusNames(),
        rateRules: createRateRules(),
        googleCode: "",
      },
      initialMainCurrency: "USDT",
      languages: LANGUAGES,
      rateRuleRows: RATE_RULE_ROWS,
      gameOptions: [
        { label: "彩票", value: "lottery" },
        { label: "棋牌", value: "chess" },
        { label: "电子", value: "slot" },
        { label: "小游戏", value: "mini" },
        { label: "真人", value: "live" },
        { label: "体育", value: "sport" },
        { label: "德州", value: "texas" },
        { label: "自营游戏", value: "self" },
      ],
      gameDialog: {
        show: false,
        row: null,
        selected: [],
      },
    };
  },
  computed: {
    currencyOptions() {
      return this.currencyRows.map((item) => ({
        label: item.CurrencyCode,
        value: item.CurrencyCode,
      }));
    },
    activeLanguageLabel() {
      const current = this.languages.find(
        (item) => item.code == this.form.activeLanguage
      );
      return current ? current.label : "中文(zh)";
    },
  },
  mounted() {
    this.loadCurrencyOptions();
  },
  methods: {
    loadCurrencyOptions() {
      const data = {
        Page: 1,
        PageSize: 500,
        page: 1,
        pagesize: 500,
        State: 1,
      };
      app
        .service({
          url: "/multi_wallet/currency/config/list",
          method: "post",
          data,
        })
        .then((res) => {
          if (!res.data || res.data.code != 200) return;
          const list = this.getResponseList(res.data.data);
          this.mergeCurrencyMaster(list);
          this.loadSellerConfig();
        })
        .catch(() => {
          this.currencyRows = [];
        });
    },
    loadSellerConfig() {
      if (!this.sellerId && this.sellerId !== 0) return;
      app
        .service({
          url: "/admin/seller/currency_config/detail",
          method: "post",
          data: { SellerId: this.sellerId },
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.applySellerConfig(res.data.data || {});
          }
        })
        .catch(() => { });
    },
    getResponseList(data) {
      if (!data) return [];
      if (Array.isArray(data)) return data;
      if (Array.isArray(data.list)) return data.list;
      if (Array.isArray(data.data)) return data.data;
      if (data.data && Array.isArray(data.data.list)) return data.data.list;
      if (data.data && Array.isArray(data.data.data)) return data.data.data;
      return [];
    },
    mergeCurrencyMaster(list) {
      this.currencyRows = list.reduce((rows, item) => {
        const code = this.getFirstValue(item, [
          "CurrencyCode",
          "Symbol",
          "CoinSymbol",
        ]);
        const currencyCode = this.normalizeCurrencyCode(code);
        if (!currencyCode) return rows;
        rows.push(
          createCurrencyRow({
            CurrencyCode: currencyCode,
            CurrencyName:
              this.getFirstValue(item, ["CurrencyName", "SymbolName"]) ||
              currencyCode,
          })
        );
        return rows;
      }, []);

      if (
        !this.form.mainCurrency ||
        !this.currencyRows.some((item) => item.CurrencyCode == this.form.mainCurrency)
      ) {
        this.form.mainCurrency = this.currencyRows.length
          ? this.currencyRows[0].CurrencyCode
          : "";
        this.initialMainCurrency = this.form.mainCurrency;
      }
    },
    applySellerConfig(data) {
      const mainCurrency = this.normalizeCurrencyCode(
        this.getFirstValue(data, ["MainCurrency", "PSymbol", "Symbol"])
      );
      if (
        mainCurrency &&
        this.currencyRows.some((row) => row.CurrencyCode == mainCurrency)
      ) {
        this.form.mainCurrency = mainCurrency;
        this.initialMainCurrency = mainCurrency;
      }

      const bonusNames =
        data.BonusNames ||
        data.BonusName ||
        data.BonusLangs ||
        data.BonusNameLangs ||
        {};
      Object.keys(this.form.bonusNames).forEach((lang) => {
        if (bonusNames[lang] !== undefined && bonusNames[lang] !== null) {
          this.form.bonusNames[lang] = String(bonusNames[lang]);
        }
      });

      this.applyRateRule(data, "rechargeFiat", [
        "RechargeFiatRateFixType",
        "RechargeFiatFixType",
        "RechargeFiatType",
      ], [
        "RechargeFiatRateFixValue",
        "RechargeFiatFix",
        "RechargeFiatValue",
      ]);
      this.applyRateRule(data, "rechargeVirtual", [
        "RechargeVirtualRateFixType",
        "RechargeVirtualFixType",
        "RechargeVirtualType",
      ], [
        "RechargeVirtualRateFixValue",
        "RechargeVirtualFix",
        "RechargeVirtualValue",
      ]);
      this.applyRateRule(data, "withdrawFiat", [
        "WithdrawFiatRateFixType",
        "WithdrawFiatFixType",
        "WithdrawFiatType",
      ], [
        "WithdrawFiatRateFixValue",
        "WithdrawFiatFix",
        "WithdrawFiatValue",
      ]);
      this.applyRateRule(data, "withdrawVirtual", [
        "WithdrawVirtualRateFixType",
        "WithdrawVirtualFixType",
        "WithdrawVirtualType",
      ], [
        "WithdrawVirtualRateFixValue",
        "WithdrawVirtualFix",
        "WithdrawVirtualValue",
      ]);

      const list =
        data.CurrencyList ||
        data.EnabledCurrencies ||
        data.Currencies ||
        data.list ||
        [];
      if (Array.isArray(list) && list.length) {
        this.mergeSellerCurrencyRows(list);
      }
    },
    applyRateRule(data, key, typeFields, valueFields) {
      const type = this.getFirstValue(data, typeFields);
      const value = this.getFirstValue(data, valueFields);
      if (type !== undefined && type !== null && type !== "") {
        this.form.rateRules[key].type = Number(type);
      }
      if (value !== undefined && value !== null) {
        this.form.rateRules[key].value = String(value);
      }
    },
    mergeSellerCurrencyRows(list) {
      const rowMap = {};
      this.currencyRows.forEach((row) => {
        rowMap[this.normalizeCurrencyCode(row.CurrencyCode)] = row;
      });

      list.forEach((item) => {
        const code = this.normalizeCurrencyCode(
          this.getFirstValue(item, ["CurrencyCode", "Symbol", "CoinSymbol"])
        );
        if (!code) return;

        if (!rowMap[code]) return;

        const row = rowMap[code];
        row.Enabled = this.parseBoolean(
          this.getFirstValue(item, ["Enabled", "Enable", "IsEnable", "State"]),
          row.Enabled,
          true
        );
        row.WalletTypes = this.parseWalletTypes(item, row.WalletTypes);
        if (row.Enabled && row.WalletTypes.indexOf("real") == -1) {
          row.WalletTypes.unshift("real");
        }
        row.SelfGameBet = this.parseBoolean(
          this.getFirstValue(item, [
            "SelfGameBet",
            "SupportSelfGameBet",
            "SelfGameState",
            "IsSelfGame",
          ]),
          row.SelfGameBet
        );
        row.DirectThirdGame = this.parseBoolean(
          this.getFirstValue(item, [
            "DirectThirdGame",
            "BringThirdGame",
            "DirectThirdState",
            "IsDirectThird",
          ]),
          row.DirectThirdGame
        );
        const directThirdSymbol = this.normalizeCurrencyCode(
          this.getFirstValue(item, [
            "DirectThirdSymbol",
            "ThirdGameSymbol",
            "ThirdCurrency",
            "MappingSymbol",
          ])
        );
        if (directThirdSymbol || row.DirectThirdSymbol) {
          row.DirectThirdSymbol = directThirdSymbol || row.DirectThirdSymbol;
        }
        const supportGames = this.getFirstValue(item, [
          "SupportGames",
          "GameTypes",
          "Games",
        ]);
        row.SupportGames = this.parseArray(supportGames);
        const fee = this.getFirstValue(item, [
          "ExchangeFee",
          "ExchangeFeeRate",
          "HandlingFee",
          "MoveExchangeFee",
        ]);
        if (fee !== undefined && fee !== null && fee !== "") {
          row.ExchangeFee = String(fee);
          row.ShowExchangeFee = true;
        }
      });
    },
    getFirstValue(source, fields) {
      if (!source) return undefined;
      for (let i = 0; i < fields.length; i++) {
        const value = source[fields[i]];
        if (value !== undefined && value !== null && value !== "") {
          return value;
        }
      }
      return undefined;
    },
    normalizeCurrencyCode(code) {
      if (code === undefined || code === null) return "";
      return String(code).trim().toUpperCase();
    },
    parseBoolean(value, defaultValue, stateAsEnable) {
      if (value === undefined || value === null || value === "") {
        return !!defaultValue;
      }
      if (typeof value == "boolean") return value;
      if (typeof value == "number") {
        if (stateAsEnable) return value == 1;
        return value == 1;
      }
      const text = String(value).toLowerCase();
      return ["1", "true", "yes", "open", "enable", "enabled"].indexOf(text) > -1;
    },
    parseArray(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value.slice();
      return String(value)
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    },
    parseWalletTypes(item, defaultValue) {
      const walletTypes = this.getFirstValue(item, [
        "WalletTypes",
        "EnableWalletTypes",
        "WalletType",
      ]);
      const parsed = this.parseArray(walletTypes).map((item) => {
        const text = String(item).toLowerCase();
        if (text == "1" || text == "real" || text == "true") return "real";
        if (text == "2" || text == "bonus" || text == "gift") return "bonus";
        return item;
      });
      if (parsed.length) return parsed;

      const result = Array.isArray(defaultValue) ? defaultValue.slice() : [];
      if (
        this.parseBoolean(
          this.getFirstValue(item, ["RealWallet", "TrueMoney", "OpenRealWallet"]),
          false
        ) &&
        result.indexOf("real") == -1
      ) {
        result.push("real");
      }
      if (
        this.parseBoolean(
          this.getFirstValue(item, ["BonusWallet", "GiftWallet", "OpenBonusWallet"]),
          false
        ) &&
        result.indexOf("bonus") == -1
      ) {
        result.push("bonus");
      }
      return result;
    },
    handleCurrencyEnabledChange(row) {
      if (row.Enabled && row.WalletTypes.indexOf("real") == -1) {
        row.WalletTypes.unshift("real");
      }
    },
    openGameDialog(row) {
      this.gameDialog.row = row;
      this.gameDialog.selected = Array.isArray(row.SupportGames)
        ? row.SupportGames.slice()
        : [];
      this.gameDialog.show = true;
    },
    saveGameDialog() {
      if (this.gameDialog.row) {
        this.gameDialog.row.SupportGames = this.gameDialog.selected.slice();
      }
      this.gameDialog.show = false;
    },
    handleConfirm() {
      if (!this.form.googleCode) {
        this.$message.warning("请输入谷歌验证码");
        return;
      }

      if (this.form.mainCurrency != this.initialMainCurrency) {
        this.$confirm(
          `确认将主货币从 ${this.initialMainCurrency} 变更为 ${this.form.mainCurrency}？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.submit();
          })
          .catch(() => { });
        return;
      }

      this.submit();
    },
    submit() {
      const data = this.getSubmitData();
      app.post("/admin/seller/currency_config/update", data, () => {
        this.$message.success("保存成功");
        this.$emit("success");
        this.$emit("close");
      });
    },
    getSubmitData() {
      const currencyList = this.currencyRows.map((row) => {
        if (row.Enabled && row.WalletTypes.indexOf("real") == -1) {
          row.WalletTypes.unshift("real");
        }
        const realWallet = row.Enabled ? 1 : 2;
        const bonusWallet = row.WalletTypes.indexOf("bonus") > -1 ? 1 : 2;
        return {
          CurrencyCode: row.CurrencyCode,
          Symbol: row.CurrencyCode,
          Enabled: row.Enabled ? 1 : 2,
          Enable: row.Enabled ? 1 : 2,
          WalletTypes: row.WalletTypes,
          RealWallet: realWallet,
          BonusWallet: bonusWallet,
          SupportSelfGameBet: row.SelfGameBet ? 1 : 2,
          SelfGameBet: row.SelfGameBet ? 1 : 2,
          DirectThirdGame: row.DirectThirdGame ? 1 : 2,
          DirectThirdSymbol: row.DirectThirdSymbol,
          SupportGames: row.SupportGames,
          ExchangeFee: row.ShowExchangeFee ? row.ExchangeFee : "",
          ShowExchangeFee: row.ShowExchangeFee ? 1 : 2,
        };
      });

      return {
        SellerId: this.sellerId,
        MainCurrency: this.form.mainCurrency,
        Symbol: this.form.mainCurrency,
        CurrencyList: currencyList,
        EnabledCurrencies: currencyList.filter((item) => item.Enabled == 1),
        BonusNames: this.form.bonusNames,
        RechargeFiatRateFixType: this.form.rateRules.rechargeFiat.type,
        RechargeFiatRateFixValue: this.form.rateRules.rechargeFiat.value,
        RechargeVirtualRateFixType: this.form.rateRules.rechargeVirtual.type,
        RechargeVirtualRateFixValue: this.form.rateRules.rechargeVirtual.value,
        WithdrawFiatRateFixType: this.form.rateRules.withdrawFiat.type,
        WithdrawFiatRateFixValue: this.form.rateRules.withdrawFiat.value,
        WithdrawVirtualRateFixType: this.form.rateRules.withdrawVirtual.type,
        WithdrawVirtualRateFixValue: this.form.rateRules.withdrawVirtual.value,
        GoogleCode: this.form.googleCode,
      };
    },
  },
};
</script>

<style scoped>
.seller-currency-config {
  color: #4a4f57;
  font-size: 14px;
  padding-left: 84px;
}

.main-currency-row,
.currency-table-row,
.bonus-name-row,
.google-code-row {
  display: flex;
  align-items: flex-start;
}

.main-currency-row {
  align-items: center;
  margin-bottom: 18px;
}

.form-label {
  flex: 0 0 142px;
  line-height: 32px;
  padding-right: 12px;
  text-align: right;
}

.main-currency-select {
  width: 150px;
}

.main-currency-tip {
  margin-left: 8px;
  color: #606266;
  line-height: 32px;
}

.table-label {
  line-height: 40px;
}

.seller-currency-table {
  width: 950px;
}

.enabled-currency-code {
  color: #1989fa;
  font-weight: 600;
}

.header-tip-icon,
.rate-tip-icon {
  margin-left: 4px;
  color: #909399;
  font-size: 13px;
}

.wallet-type-group {
  white-space: nowrap;
}

.third-game-cell,
.fee-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.third-game-select {
  width: 150px;
  margin-left: 14px;
}

.setting-link {
  font-weight: 600;
}

.fee-input {
  width: 100px;
  margin-right: 6px;
}

.bonus-name-row {
  margin-top: 22px;
}

.bonus-name-content {
  width: 950px;
}

.language-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.language-buttons .el-button {
  margin: 0;
  min-width: 78px;
  height: 32px;
  padding: 8px 14px;
  border-radius: 4px;
}

.bonus-input-label {
  margin-top: 14px;
  color: #7a828e;
  line-height: 20px;
}

.bonus-name-input {
  width: 500px;
  margin-top: 8px;
}

.rate-rules {
  margin-top: 20px;
}

.rate-rule-row {
  display: flex;
  align-items: center;
  height: 51px;
}

.required-star {
  width: 12px;
  color: #ff4949;
  text-align: right;
}

.rate-rule-label {
  width: 156px;
  text-align: right;
}

.rate-tip-icon {
  margin-right: 6px;
}

.rate-value-input {
  width: 130px;
  margin: 0 8px;
}

.google-code-row {
  align-items: center;
  margin-top: 2px;
}

.google-label {
  width: 148px;
  text-align: right;
}

.google-input {
  width: 950px;
  margin-left: 8px;
}

.seller-currency-footer {
  margin-top: 58px;
  text-align: center;
}

.game-dialog-footer {
  text-align: center;
}

.game-options {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 22px;
}

.seller-currency-table ::v-deep .el-table__header th {
  height: 49px;
  padding: 0;
  font-size: 12px;
}

.seller-currency-table ::v-deep .el-table__body td {
  height: 48px;
  padding: 0;
}

.seller-currency-table ::v-deep .el-checkbox {
  margin-right: 0;
}

.seller-currency-table ::v-deep .el-checkbox__label {
  padding-left: 8px;
}

.seller-currency-table ::v-deep .el-switch__core {
  width: 40px !important;
}

.seller-currency-table ::v-deep .el-input__inner,
.main-currency-select ::v-deep .el-input__inner,
.bonus-name-input ::v-deep .el-input__inner,
.google-input ::v-deep .el-input__inner,
.rate-value-input ::v-deep .el-input__inner {
  height: 32px;
  line-height: 32px;
}
</style>
